import { safeSessionStorage } from "./storage";

const SOFTWALL_BOUNCE_KEY = "BT_AM_SOFTWALL_BOUNCE";

export const hasBounceData = () =>
  safeSessionStorage.get(SOFTWALL_BOUNCE_KEY) === "true";

export const saveBounceData = () =>
  safeSessionStorage.set(SOFTWALL_BOUNCE_KEY, "true");
export const deleteBounceData = () =>
  safeSessionStorage.remove(SOFTWALL_BOUNCE_KEY);
